import React from 'react';
import { Box, styled } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const getChoiceButtonStyle = (theme: Theme): React.CSSProperties => ({
  width: '100%',
  borderRadius: 100,
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
});
